export default __webpack_public_path__ + "static/assets/2699b5edfe9fabb5e01e18141be34ac6.png";